import React, { Component } from 'react'

class Footer extends Component {
    render() {
        return (
            <div className="card">
                <div className="card-info text-center">
                    <span className="card-title">@Copy-right-2021</span>
                </div>
            </div>
        )
    }
}

export default Footer
